<template>
  <div v-show="currentPage" class="page-controller-component">
    <button
      class="page-btn"
      :class="{ 'is-disabled': currentPage === 1 }"
      :disabled="currentPage === 1"
      @click="handlePrevPage"
      tabindex="0"
      aria-label="上一页"
    >
      <el-tooltip
        popper-class="live-room-tooltip"
        effect="dark"
        content="上一页"
        placement="top"
        :disabled="isHXApp"
      >
        <i class="el-icon-caret-left"></i>
      </el-tooltip>
    </button>
    <span
      class="page-info"
      :class="{
        'is-last-page': isLastPage,
      }"
      >{{ currentPage }}/{{ totalPages }}</span
    >
    <button
      class="page-btn"
      @click="isLastPage && isWhiteBoard ? handleAddPage() : handleNextPage()"
      tabindex="0"
      :aria-label="isLastPage && isWhiteBoard ? '添加一页' : '下一页'"
      :class="{
        'is-last-page': isLastPage,
        'is-disabled': isLastPage && !isWhiteBoard,
      }"
    >
      <el-tooltip
        popper-class="live-room-tooltip"
        effect="dark"
        :content="isLastPage && isWhiteBoard ? '添加一页' : '下一页'"
        placement="top"
        :disabled="isHXApp"
      >
        <i
          :class="
            isLastPage && isWhiteBoard ? 'el-icon-plus' : 'el-icon-caret-right'
          "
        ></i>
      </el-tooltip>
    </button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      currentPage: 1,
      totalPages: 1,
    };
  },
  computed: {
    ...mapState("live", ["whiteBoardService", "isHXApp", "whiteboardType"]),
    isLastPage() {
      return this.currentPage === this.totalPages;
    },
    // 是否是默认白板
    isWhiteBoard() {
      return this.whiteboardType === "whiteboard";
    },
  },
  methods: {
    handlePrevPage() {
      if (this.currentPage > 1) {
        this.whiteBoardService.prevBoard();
      }
    },
    handleNextPage() {
      if (this.currentPage < this.totalPages) {
        this.whiteBoardService.nextBoard();
      }
    },
    handleAddPage() {
      this.whiteBoardService.addBoard();
    },
  },
  watch: {
    "$store.state.whiteBoard.currentFileInfo": {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.currentPage = newValue.currentPageIndex + 1;
          this.totalPages = newValue.pageCount;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.page-controller-component {
  height: 38px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(20, 20, 43, 0.04);
  border-radius: 10px 10px 10px 10px;
  border: 1px solid $live-room-border-color;
  display: flex;
  align-items: center;
  margin-right: 10px;
  padding: 2px 0;
  .page-btn {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    i {
      font-size: 14px;
      color: #1d2129;
      font-weight: bold;
    }

    &.is-disabled {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: auto;
    }
    &.is-last-page {
      margin-right: 2px;
    }
  }

  .page-info {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    color: #1d2129;
    line-height: 1;
    margin: 0 6px;
    &.is-last-page {
      margin-right: 4px;
    }
  }
}
</style>
